// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const pipe = (...fns)=>(x)=>fns.reduce((v, f)=>f(v), x);
export function round(precision) {
    return (n)=>Math.round(n * Math.pow(10, precision)) / Math.pow(10, precision);
}
export function fallback(def) {
    return (n)=>Number.isNaN(Number(n)) ? def : Number(n);
}
export function clamp([min, max]) {
    return (n)=>{
        if (n > max) return max;
        if (n < min) return min;
        return n;
    };
}
export const percentInteger = pipe(fallback(0), clamp([
    0,
    100
]), round(0));
